/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import FormFader from "../Common/Fader/FormFader";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import { Box, InputAdornment } from "@mui/material";
import { useForm } from "../../../provider/Form/FormProvider";
import Group from "../../Wizard/Group";
import { requiredValidator } from "../../../services/validationRules";
import DialogModal from "../../DialogModal/DialogModal";
import { useLocation, useNavigate } from "react-router";
import Typography from "@mui/material/Typography";
import NumberFieldConfigured from "../ConfiguredFormElements/NumberFieldConfigured/NumberFieldConfigured";
import { AbstractCase } from "../../../types/Entities/AbstractCase";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import InfoIconButton from "../../Button/InfoIconButton";

type IncomeSelfEmploymentProps = {
  submitProps: FormSubmitProps;
  product: AbstractCase;
};

export default function IncomeSelfEmployment({ submitProps, product }: IncomeSelfEmploymentProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { values, handleSubmit } = useForm();

  const modalOpen = () => {
    navigate(location.pathname, { state: { incomeEmploymentModalOpen: true } });
  };

  const modalClose = () => {
    navigate(-1);
  };

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={wizardStyle.wizardForm} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Einnahmen
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "center",
            }}
          >
            <Grid size={12}>
              <Group
                type={"radio"}
                name={"hasIncomeSelfEmployment"}
                question={"Haben Sie Einnahmen aus selbständiger Arbeit, Gewerbebetrieb oder Land- und Forstwirtschaft?"}
                options={[
                  {
                    labelText: "Nein",
                    labelIcon: <CrossIcon />,
                    labelIconActive: <CrossIcon active />,
                    value: "no",
                  },
                  {
                    labelText: "Ja",
                    labelIcon: <CheckIcon />,
                    labelIconActive: <CheckIcon active />,
                    value: "yes",
                  },
                ]}
                validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
              />
            </Grid>
            {values.hasIncomeSelfEmployment === "yes" && (
              <NumberFieldConfigured
                caseData={product}
                fieldPath={"incomeSelfEmploymentAmount"}
                required
                numberType={"float"}
                fieldType={"money"}
                inputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <InfoIconButton onClick={modalOpen} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
      <DialogModal open={!!(location.state && location.state.incomeEmploymentModalOpen)} onClose={modalClose} title={"Einnahmen richtig berechnen"}>
        <p>
          Wenn Ihr Unternehmen noch Verluste macht, tragen Sie einfach "0" ein. Andernfalls geben Sie einen monatlichen Durchschnittsverdienst über das letzte
          Jahr an.
        </p>
      </DialogModal>
    </Paper>
  );
}
